export default "__VITE_PUBLIC_ASSET__006b9e00__"